var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-5"},[_c('b-col',[(_vm.isAdmin || _vm.isGrafico)?_c('b-button',{attrs:{"to":"/progetto/"}},[_vm._v("Crea")]):_vm._e(),_c('ProjectsSearch',{staticClass:"mb-2"}),_c('ProjectsTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }